import { render, staticRenderFns } from "./CinemaInfo.vue?vue&type=template&id=47e8c3ed&scoped=true"
import script from "./CinemaInfo.vue?vue&type=script&lang=js"
export * from "./CinemaInfo.vue?vue&type=script&lang=js"
import style0 from "./CinemaInfo.vue?vue&type=style&index=0&id=47e8c3ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8c3ed",
  null
  
)

export default component.exports